import { render, staticRenderFns } from "./nbEditfrom.vue?vue&type=template&id=70d34e12&"
import script from "./nbEditfrom.vue?vue&type=script&lang=js&"
export * from "./nbEditfrom.vue?vue&type=script&lang=js&"
import style0 from "./nbEditfrom.vue?vue&type=style&index=0&id=70d34e12&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports